import React from "react";
import "./style.css";

const Loader = ({ text,is_shown }) => {
  const [isPageLoading, setIsPageLoading] = React.useState(true);

  React.useEffect(() => {
    setIsPageLoading(is_shown);
  }, [is_shown]);

  return (
    <div className={`full-page-loader ${isPageLoading ? "" : "hidden"}`}>
      <div className="full-page-spinner"></div>
      <div className="full-page-loader-text">{text}</div>
      <div className="full-page-loader-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
};

export default Loader;
